import {
  Box,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@material-ui/core";

import AiInsightsIcon from "~/icons/aiInsightsIcon";
import AutoSizedButton from "~/components/buttons/autoSizedButton";
import { BaseDialog } from "~/components/dialogs/baseDialog";
import CloseIcon from "@material-ui/icons/Close";
import GenericSvgIconWrapper from "~/icons/genericSvgIconWrapper";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const DEFAULT_CREDITS = 5000;
const DialogHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
`;

const HeaderLeft = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const CloseButton = styled(IconButton)`
  right: 1 rem;
`;

const Divider = styled.hr`
  border: none;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.grey[300]};
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 1.5rem;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: grey;
`;

const StyledCreditsBox = styled.div`
  padding: 5px 10px;
  margin-top: 1rem;
  width: 90%;
  color: grey;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 8px;
`;

const StyledCredit = styled(Typography)`
  right: 1rem;
  color: ${({ theme }) => theme.palette.secondary.main};
  font-weight: bold;
`;

const StyledDialogActions = styled(DialogActions)`
  padding: 1.5rem;
  border: 0;
`;

interface CommentsCreditsDialogProps {
  open: boolean;
  onClose: () => void;
  setAnchorEl: React.Dispatch<React.SetStateAction<boolean>>;
}

const CommentsCreditsDialog: React.FC<CommentsCreditsDialogProps> = ({
  open,
  onClose,
  setAnchorEl,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          maxHeight: "none",
        },
      }}
    >
      <DialogHeader>
        <HeaderLeft>
          <Typography variant="h1">
            {t("reportComments.creditsDialogTitle")}
          </Typography>
        </HeaderLeft>
        <CloseButton onClick={onClose} aria-label="close">
          <GenericSvgIconWrapper
            $color={theme.palette.text.secondary}
            $width="1.5rem"
            $height="1.5rem"
          >
            <CloseIcon />
          </GenericSvgIconWrapper>
        </CloseButton>
      </DialogHeader>
      <Divider />
      <StyledDialogContent>
        <Box width="90%">
          <Typography>{t("reportComments.creditsDialogContent")}</Typography>
        </Box>
        <StyledCreditsBox>
          <Typography>{t("reportComments.creditsDialogRemain")}</Typography>
          <StyledCredit>{DEFAULT_CREDITS.toLocaleString()}</StyledCredit>
          <AiInsightsIcon />
        </StyledCreditsBox>
      </StyledDialogContent>
      <Divider />
      <StyledDialogActions>
        <Grid container spacing={1}>
          <Grid item>
            <AutoSizedButton
              variant="contained"
              color="secondary"
              onClick={() => {
                onClose();
                setAnchorEl(true);
              }}
            >
              {t("reportComments.creditsDialog.showMeBtn").toUpperCase()}
            </AutoSizedButton>
          </Grid>
          <Grid item>
            <AutoSizedButton
              variant="outlined"
              color="secondary"
              onClick={onClose}
            >
              {t("reportComments.creditsDialog.mayLaterBtn").toUpperCase()}
            </AutoSizedButton>
          </Grid>
          <Grid item>
            <AutoSizedButton variant="text" onClick={onClose}>
              {t("generic.closeButton").toUpperCase()}
            </AutoSizedButton>
          </Grid>
        </Grid>
      </StyledDialogActions>
    </BaseDialog>
  );
};

export default CommentsCreditsDialog;
